import React from 'react';
import { detect } from 'detect-browser';
import { buildOrganizationSchema, buildBreadcrumbSchema } from "../../utils/schemaBuilders";
// import SchemaMarkup from "../SchemaMarkup/SchemaMarkup";
import "./BrowserInfo.scss";

/**
    Provides information about the users current browser.
 */
export default class BrowserInfo extends React.Component {
    /**
     * @constructor
     * Creates a new instance of BrowserInfo
     */
    constructor() {
        super();

        this.state = {
            dateTime: new Date().toISOString(),
            browserInfo: detect(),
            geoLocation: {
                message: 'Loading browser geo location information ...'
            },
            ezClockerVersionInfo: {
                message: 'Loading ezClocker version information ...'
            }
        };
    }

    /**
     * @public @function
     * Executed after the component is mounted. Loads the browser's current date time and geolocation information and sets the state with that information
     */
    componentDidMount() {
        this.loadBrowserGeolocationInfo();

        this.loadEzClockerVersionInfo();
    }

    /**
     * @public @function
     * Sets the state with the browser's current date time and geolocation information
     */
    loadBrowserGeolocationInfo() {
        navigator.geolocation.getCurrentPosition(
            (geoLocationResponse) => {
                let nowDateTime = new Date();

                this.setState({
                    displayDateTime: nowDateTime.toString(),
                    browserInfo: detect(),
                    geoLocation: geoLocationResponse
                })
            },
            (error) => {
                let nowDateTime = new Date();

                this.setState({
                    displayDateTime: nowDateTime.toString(),
                    browserInfo: detect(),
                    geoLocation: {
                        errorCode: error.code,
                        message: error.message
                    }
                });
            });
    }

    /**
     * @public @function
     * Sets the state with the ezClocker version information
     */
    loadEzClockerVersionInfo() {
        const currentOrigin =  window.location.origin;

        const ezVersionUrl = currentOrigin.includes('localhost') || currentOrigin.includes('127.0.0.1')
            ? 'https://ezclocker.com/version'
            : `${currentOrigin}/version`;

        return fetch(ezVersionUrl)
            .then(
                (response) => {
                    response.json()
                        .then((jsonResponse) => {
                            console.log('EzClocker Version Info Response: ', jsonResponse);

                            this.setState({
                                ezClockerVersionInfo: jsonResponse
                            });
                        })
                    response.json()
                        .then((jsonResponse) => {
                            console.log('EzClocker Version Info Response: ', jsonResponse);

                            this.setState({
                                ezClockerVersionInfo: jsonResponse
                            });
                        })
                        .catch((error) => {
                            console.error('Error parsing version info JSON:', error);
                            this.setState({
                                ezClockerVersionInfo: {
                                    message: 'Failed to parse version information'
                                }
                            });
                        });
                },
                (eResponse) => {
                    console.log('EzClocker Version Info Response: ', eResponse);

                    this.setState({
                        ezClockerVersionInfo: eResponse
                    });
                })
            .catch((error) => {
                console.error('Error fetching version info:', error);
                this.setState({
                    ezClockerVersionInfo: {
                        message: 'Failed to fetch version information'
                    }
                });
            });
    }

    render() {
        const schema = [
            buildOrganizationSchema(),
            buildBreadcrumbSchema("Browser Info", "/browser-info")
        ];
        return (
            <main
                id="EzBrowserInfoPage"
                className="ezBrowserInfoPage">
                <h3
                    id="EzBrowserInfoTitle">
                    Your Web Browser Information
                </h3>
                <ul
                    id="EzBrowserInfoList">
                    <li
                        id="EzBrowserDateTime">
                        <strong>Browser Date/Time:</strong> {this.state.displayDateTime}
                    </li>
                    <li
                        id="EzBrowserInfoName">
                        <strong>Browser Name:</strong> {this.state.browserInfo.name}
                    </li>
                    <li
                        id="EzBrowserInfoVersion">
                        <strong>Browser Version:</strong> {this.state.browserInfo.version}
                    </li>
                    <li
                        id="EzBrowserInfoOS">
                        <strong>Browser OS:</strong> {this.state.browserInfo.os}
                    </li>
                    <li
                        id="EzBrowserGeoLocationInfo">
                        <strong>Browser Geo Location:</strong> {JSON.stringify(this.state.geoLocation, null, 3)}
                    </li>
                </ul>
                <h3
                    id="EzClockerVersionInfo">
                    EzClocker Version Information
                </h3>
                <ul
                    id="EzClockerVersionInfoList">
                    <li
                        id="EzClockerVersionEnviornmentId">
                        <strong>Envrionment:</strong> {this.state.ezClockerVersionInfo.ezEnvironmentId}
                    </li>
                    <li
                        id="EzClockerVersionWebsiteVersion">
                        <strong>Website version:</strong> {this.state.ezClockerVersionInfo.websiteVersion}
                    </li>
                    <li
                        id="EzClockerVersionServicesVersion">
                        <strong>Api version:</strong> {this.state.ezClockerVersionInfo.servicesVersion}
                    </li>
                </ul>
                <h3
                    id="EzAdditionalInformation">
                </h3>
                <div id="EzAdditionalInformationDisplay">
                    { JSON.stringify(schema, null, 3) }
                </div>
            </main>);
    }
}
